import { AlgorithmUsage, type IListAlgorithmUsageHandler, ListAlgorithmUsage } from '@protocols/use-cases';
import { CloudFunctions } from '@telespot/sdk';

export class ListAlgorithmUsageHandler implements IListAlgorithmUsageHandler {
  public async execute(command: ListAlgorithmUsage): Promise<AlgorithmUsage> {
    return CloudFunctions.ListAlgorithmUsage({
      algorithmId: command.details.algorithmId,
      batchSize: command.details.batchSize,
    });
  }
}
